import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const isValidId = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined";

export const useConsultationServices = (consultationId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["consultationPaymentsDue", consultationId, tenantVal],
    queryFn: async () => {
      if (!isValidId(consultationId)) return null;

      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultationpaymentdue/getbyconsultationid/${consultationId}`
      );
      return response.data;
    },
    enabled: isValidId(consultationId) && !!tenantVal,
    meta: { errorMessage: "Error fetching consultation services" },
   
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};
